var _defs, _circle, _rect, _path, _path2, _path3, _path4, _line, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSummary = function SvgSummary(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.19 227.28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7b8fb5;}.cls-2{fill:none;stroke:#5073b6;stroke-linecap:round;stroke-miterlimit:10;stroke-width:4px;}.cls-3{fill:#a1a8b5;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_110",
    className: "cls-1",
    cx: 114.59,
    cy: 113.64,
    r: 111.18
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_788",
    className: "cls-3",
    x: 36.69,
    y: 61.14,
    width: 153,
    height: 105,
    rx: 4,
    ry: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m181.59,79.31H47.59c-.55,0-1-.45-1-1s.45-1,1-1h134c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m158.08,70.31h-7c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h7c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m178.08,69.81l2.34-2.13c.2-.19.22-.5.03-.71-.19-.2-.5-.22-.71-.03l-2.4,2.19-2.4-2.19c-.2-.19-.52-.17-.71.03s-.17.52.03.71l2.34,2.13-2.34,2.13c-.2.19-.22.5-.03.71.1.11.23.16.37.16.12,0,.24-.04.34-.13l2.4-2.19,2.4,2.19c.1.09.22.13.34.13.14,0,.27-.05.37-.16.19-.2.17-.52-.03-.71l-2.34-2.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.59,72.51h-7v-6h7v6Zm-6-1h5v-4h-5v4Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 119.87,
    y1: 99.13,
    x2: 106.51,
    y2: 142.31
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m96.13,110.02l-17.74,10.24c-.35.2-.35.71,0,.92l17.74,10.24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m130.25,110.02l17.74,10.24c.35.2.35.71,0,.92l-17.74,10.24"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSummary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "summary.1eace6ea1778603c767f0b088851df51.svg";